module.exports = __webpack_public_path__ + "img/user-board_bg.b6505590.png";